(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CustomerNotification', CustomerNotification);

    CustomerNotification.$inject = ['$resource', 'DateUtils'];

    function CustomerNotification ($resource, DateUtils) {
        var resourceUrl =  'api/customer-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pushDate = DateUtils.convertDateTimeFromServer(data.pushDate);
                        data.expiryDate = DateUtils.convertDateTimeFromServer(data.expiryDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
